<!-- 
  @desc 教练员培训
-->
<template>
  <el-container class="main_panel" direction="vertical" data-a="666">
    <!-- 表头 -->
    <el-row v-if="!isHideBreadMenu">
      <el-col :span="24">
        <title-bar :titleBar="'教练员培训'"></title-bar>
      </el-col>
    </el-row>
    <!-- 筛选 -->
    <el-container direction="vertical" class="content_panel">
      <el-row :gutter="16" class="search_panel">
        <!-- 年度 -->
        <el-col :span="4">
          <el-select v-model="ClassPageListVO.year" placeholder="年度" size="small" @change="classPagelist" clearable>
            <el-option v-for="(item, index) in yearList" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-col>
        <!-- 所属单位 -->
        <el-col :span="4" v-if="isSearch">
          <el-select
            placeholder="所属单位"
            size="small"
            v-model="ClassPageListVO.orgId"
            filterable
            clearable
            @change="classPagelist"
          >
            <el-option
              v-for="item in dict.sportsAuthority"
              :key="item.code"
              :value="item.code"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-col>
        <!-- 状态 -->
        <el-col :span="4">
          <el-select
            v-model="ClassPageListVO.approveStatus"
            placeholder="审批状态"
            size="small"
            @change="classPagelist"
            clearable
          >
            <template v-for="(item, index) in dict.approveStatus">
              <el-option
                v-if="(role === 'QSS' && index > 0) || role != 'QSS'"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </template>
          </el-select>
        </el-col>
        <!-- 项目 -->
        <!-- <el-col :span="4">
          <el-select
            v-model="ClassPageListVO.discipline"
            placeholder="项目"
            size="small"
            @change="classPagelist"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in disciplineList"
              :key="index"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col> -->
        <!-- 类型 -->
        <el-col :span="4">
          <el-select
            v-model="ClassPageListVO.type"
            placeholder="类型"
            size="small"
            @change="classPagelist"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in dict.trainingClassType"
              :key="index"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
        <!-- 省份 -->
        <el-col :span="4">
          <el-select
            v-model="ClassPageListVO.province"
            placeholder="省份"
            size="small"
            @change="classPagelist"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in dict.province"
              :key="index"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
        <!-- 名称 -->
        <el-col :span="4">
          <el-input v-model="ClassPageListVO.name" placeholder="请输入名称" size="small" @change="classPagelist">
            <i class="el-icon-search el-input__icon" slot="suffix" @click="classPagelist"></i>
          </el-input>
        </el-col>
        <!-- 查询 -->
        <el-col :span="4" :align="isSearch ? 'left' : 'right'">
          <el-button type="primary" size="small" icon="el-icon-search" @click="classPagelist">查询</el-button>
        </el-col>
        <el-col :span="isSearch ? 20 : 24" align="right">
          <!-- 新建 -->
          <el-button v-if="role !== 'QSS'" type="warning" size="small" icon="el-icon-plus" @click="classInsert"
            >新建
          </el-button>
          <!-- 批量审批 -->
          <el-button
            v-if="role === 'QSS' || role === 'SYSTEM_ADMIN'"
            type="warning"
            size="small"
            icon="el-icon-copy-document"
            @click="approveBatch"
            >批量审批
          </el-button>
          <!-- 批量提交 -->
          <el-button
            v-if="role === 'PROVINCE' || role === 'SYSTEM_ADMIN'"
            type="warning"
            size="small"
            icon="el-icon-position"
            @click="submitBatch"
            >批量提交
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            @click="handleExport()"
            v-if="role === 'QSS' || role === 'SYSTEM_ADMIN'"
          >
            导出
          </el-button>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-table :data="tableData" @selection-change="batchSelection" class="table" fit stripe size="small" border>
        <!-- 复选框 -->
        <el-table-column
          v-if="role !== 'PROVINCE_PRINCIPAL'"
          type="selection"
          align="center"
          :width="tableEventWth.checkBox"
          label=" "
        ></el-table-column>
        <!-- 类型 -->
        <!-- <el-table-column
          prop="trainingClassTypeName"
          align="left"
          :width="tableEventWth.type"
          label="类型"
        ></el-table-column> -->
        <!-- 名称 -->
        <el-table-column align="left" :min-width="tableEventWth.name" label="培训班名称">
          <template slot-scope="scope">
            <span>{{ scope.row.year + "年 · " + scope.row.name }}</span>
          </template>
        </el-table-column>
        <!-- 所属单位 -->
        <el-table-column
          v-if="role === 'QSS'"
          prop="orgName"
          align="left"
          :width="tableEventWth.orgName"
          label="所属单位"
        ></el-table-column>
        <!-- 总局拨付经费 -->
        <el-table-column :width="tableEventWth.countryFunds" label="总局拨付经费(￥)" align="right" prop="funds">
          <template slot-scope="scope">
            <div>{{ scope.row.countryFunds ? addSeparator(scope.row.countryFunds) : "" }}</div>
            <div>({{ scope.row.countryFunds ? numberToChinese(scope.row.countryFunds) : "" }})</div>
          </template>
        </el-table-column>
        <!-- 省市配套经费 -->
        <el-table-column :width="tableEventWth.provinceFunds" label="省市配套经费(￥)" align="right" prop="funds">
          <template slot-scope="scope">
            <div>{{ scope.row.provinceFunds ? addSeparator(scope.row.provinceFunds) : "" }}</div>
            <div>({{ scope.row.provinceFunds ? numberToChinese(scope.row.provinceFunds) : "" }})</div>
          </template>
        </el-table-column>
        <!-- 总经费 -->
        <el-table-column :width="tableEventWth.funds" label="总经费(￥)" align="right" prop="funds">
          <template slot-scope="scope">
            <div>{{ scope.row.funds ? addSeparator(scope.row.funds) : "" }}</div>
            <div>({{ scope.row.funds ? numberToChinese(scope.row.funds) : "" }})</div>
          </template>
        </el-table-column>
        <!-- 审批状态 -->
        <el-table-column align="left" :width="tableEventWth.approveStatus" label="审批状态">
          <template slot-scope="scope">
            <span :class="'gl_' + scope.row.approveStatus">
              {{ scope.row.approveStatusName }}
            </span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.approveRemark"
              placement="right"
              v-if="scope.row.approveStatus === 'REJECTED'"
            >
              <span class="gl_TEMP"><i class="el-icon-question"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 规模 -->
        <el-table-column
          prop="personNum"
          align="right"
          :width="tableEventWth.personNum"
          label="教练员数量"
        ></el-table-column>
        <!-- 期次 -->
        <el-table-column prop="times" align="left" :width="tableEventWth.times" label="期次"></el-table-column>
        <!-- 省市 -->
        <el-table-column align="left" :min-width="tableEventWth.cityName" label="所在省市">
          <template slot-scope="scope">
            <span>{{ scope.row.provinceName + scope.row.cityName + scope.row.address }}</span>
          </template>
        </el-table-column>
        <!-- 时间 -->
        <el-table-column align="left" :width="tableEventWth.gameDate" label="培训时间">
          <template slot-scope="scope">
            <span>{{ scope.row.beginDateTime ? scope.row.beginDateTime.substr(0, 10) : "" }}</span>
            至
            <span>{{ scope.row.endDateTime ? scope.row.endDateTime.substr(0, 10) : "" }}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="left" :width="tableEventWth.opt" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="openInfo(scope.row)">详情</el-button>
            <el-button
              size="mini"
              v-if="(role === 'QSS' || role === 'SYSTEM_ADMIN') && scope.row.approveStatus !== 'TEMP'"
              type="text"
              @click="openApprove('approve', scope.row)"
              >审批
            </el-button>
            <template v-if="role === 'PROVINCE' || role === 'SYSTEM_ADMIN' || role === 'PROVINCE_PRINCIPAL'">
              <template v-if="role !== 'PROVINCE_PRINCIPAL'">
                <el-button size="mini" v-if="scope.row.approveStatus === 'TEMP'" type="text" @click="submit(scope.row)"
                  >提交
                </el-button>
                <el-button
                  size="mini"
                  v-if="scope.row.approveStatus === 'REJECTED'"
                  type="text"
                  @click="openInfo(scope.row, 'submit')"
                  >提交
                </el-button>
                <el-button
                  size="mini"
                  v-if="scope.row.approveStatus === 'PROCESSING'"
                  type="text"
                  @click="revoke(scope.row)"
                  >撤回提交
                </el-button>
              </template>
              <el-button
                v-if="scope.row.approveStatus === 'TEMP'"
                style="color: #F56C6C;"
                size="mini"
                type="text"
                @click="classDelete(scope.row)"
                >删除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Page :total="total" @current-change="changePage" :pageSize="pageSize" />
      <!-- 审批弹框 -->
      <approve-box
        ref="approveBox"
        :approveInfo="approveInfo"
        :approveStatus="approveStatus"
        @approveSubmit="approve"
      ></approve-box>
    </el-container>
  </el-container>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { ClassPageListVO } from "@/libs/model";
import Page from "@/components/public/Page.vue";
import TitleBar from "@/components/public/TitleBar.vue";
import ApproveBox from "@/components/public/ApproveBox.vue";
export default {
  props: {
    isHideBreadMenu: Boolean,
    orgId: String
  },
  watch: {
    orgId() {
      this.classPagelist();
    }
  },
  components: {
    Page,
    TitleBar,
    ApproveBox
  },
  computed: {
    ...mapState({
      role: state => state.role,
      userInfo: state => state.userInfo
    }),
    ...mapGetters(["dictAll", "dict"])
  },
  data() {
    return {
      /**接口模块 */
      ClassPageListVO: new ClassPageListVO(),
      selectionData: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      /**单条数据的审批状态 */
      approveInfo: {},
      approveStatus: "",
      approveId: "",
      approveArrId: [],
      isApproveBatch: false,
      approveDialog: false,
      /**获取到的大项列表 */
      disciplineList: [],
      yearList: [],
      /**当前是否处于search页面 */
      isSearch: false
    };
  },
  created() {
    this.isSearch = this.$route.name.indexOf("search") > -1;
    this.getYear();
    // this.classPagelist();
    this.getDisciplineList();
  },
  methods: {
    /**获取年度信息 */
    getYear() {
      if (!this.$cache.get("yearListProvince")) {
        this.$http.getDictListYearProvince().then(response => {
          /**初始化默认项 */
          let res = this.$http.data(response);
          if (res.status === "SUCCESS") {
            this.yearList = res.data;
            /**初始化默认项 */
            for (let i = 0; i < this.yearList.length; i++) {
              if (this.yearList[i].enable) {
                this.ClassPageListVO.year = this.yearList[i].code;
                this.classPagelist();
                break;
              }
            }
            this.$cache.set("yearListProvince", res.data);
          } else {
            this.$message({
              type: "error",
              message: "获取年度信息失败"
            });
          }
        });
      } else {
        this.yearList = this.$cache.get("yearListProvince");
        /**初始化默认项 */
        for (let i = 0; i < this.yearList.length; i++) {
          if (this.yearList[i].enable) {
            this.ClassPageListVO.year = this.yearList[i].code;
            this.classPagelist();
            break;
          }
        }
      }
    },
    /**根据orgid获取大项列表 */
    getDisciplineList() {
      let _orgId = this.orgId && this.orgId != "All" ? this.orgId : this.userInfo.orgIdList[0];
      this.$http.getDictListDiscipline({ orgId: _orgId }).then(response => {
        var res = this.$http.data(response);
        if (res.status === "SUCCESS") {
          this.disciplineList = res.data;
        } else {
          this.$message({
            type: "error",
            message: "大项列表获取失败"
          });
        }
      });
    },
    /** 查询教练员培训分页列表*/
    classPagelist() {
      let _classPageListVO = JSON.parse(JSON.stringify(this.ClassPageListVO));
      if (this.orgId && this.orgId != "" && this.orgId != "All") {
        _classPageListVO.orgId = this.orgId;
      }
      this.$http.classPagelist(_classPageListVO).then(res => {
        if (res.data.status === "SUCCESS" || res.data.data.data) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.page = res.data.data.page;
        }
      });
    },
    /**复选框选中 */
    batchSelection(val) {
      this.selectionData = val;
    },
    /** 页码变化 */
    changePage(val) {
      this.ClassPageListVO.page = val;
      this.classPagelist();
    },
    /** 新增教练员培训 */
    classInsert() {
      let _name = "addClass";
      let _routerName = this.$route.name;
      _name = _routerName + "_" + _name;
      this.$router.push({
        name: _name,
        params: { id: "new" }
      });
    },
    /**查看详情 */
    openInfo(info, type) {
      let _name = "editClass";
      let _routerName = this.$route.name;
      _name = _routerName + "_" + _name;
      if (type) {
        this.$router.push({
          name: _name,
          params: { id: info.trainingClassId },
          query: { type: type }
        });
      } else {
        this.$router.push({
          name: _name,
          params: { id: info.trainingClassId }
        });
      }
    },
    /**提交教练员培训*/
    submit(info) {
      this.$confirm(`此操作将提交 [ ${info.year}年 · ${info.name} ] , 是否继续?`, "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http.classSubmit(info.trainingClassId).then(res => {
            if (res.data.status === "SUCCESS") {
              this.classPagelist();
              this.$message({ showClose: true, type: "success", message: res.data.msg });
            } else {
              this.$message({ showClose: true, type: "error", message: res.data.msg });
            }
          });
        })
        .catch(() => {
          // this.$message({ showClose: true, type: "info", message: "取消" });
        });
    },
    /**批量提交教练员培训*/
    submitBatch() {
      let _data = this.selectionData;
      let arrId = [];
      _data.forEach(item => {
        arrId.push(item.trainingClassId);
      });
      if (arrId.length === 0) {
        this.$confirm("提交时请至少选择一项?", "提示", {
          showClose: true,
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning"
        });
        return;
      }
      this.$confirm("此操作将批量提交项目, 是否继续?", "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http.classSubmitBatch(arrId).then(res => {
            if (res.data.status === "SUCCESS") {
              this.classPagelist();
              this.$message({ showClose: true, type: "success", message: res.data.msg });
            } else {
              this.$message({ showClose: true, type: "error", message: res.data.msg });
            }
          });
        })
        .catch(() => {
          // this.$message({ showClose: true, type: "info", message: "取消" });
        });
    },
    /**撤销提交教练员培训*/
    revoke(info) {
      this.$confirm(`此操作将撤销提交 [ ${info.year}年 · ${info.name} ] , 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http.classRevoke(info.trainingClassId).then(res => {
            if (res.data.status === "SUCCESS") {
              this.classPagelist();
              this.$message({ showClose: true, type: "success", message: res.data.msg });
            } else {
              this.$message({ showClose: true, type: "error", message: res.data.msg });
            }
          });
        })
        .catch(() => {
          // this.$message({ showClose: true, type: "info", message: "已取消" });
        });
    },
    /**打开审批弹出框 */
    openApprove(type, data) {
      this.approveType = type;
      this.approveInfo = {};
      if (data) {
        this.approveInfo = data;
        this.approveStatus = data.approveStatus;
        this.approveId = data.trainingClassId;
      }
      this.$refs.approveBox.openDialog();
    },
    /**审批教练员培训*/
    approve(info) {
      let _infoData = JSON.parse(JSON.stringify(info));
      if (this.isApproveBatch) {
        _infoData.idList = this.approveArrId;
        this.$http.classApproveBatch(_infoData).then(res => {
          if (res.data.status === "SUCCESS") {
            this.classPagelist();
            this.$message({ showClose: true, type: "success", message: res.data.msg });
          } else {
            this.$message({ showClose: true, type: "error", message: res.data.msg });
          }
          this.approveArrId = [];
          this.isApproveBatch = false;
        });
      } else {
        _infoData.id = this.approveId;
        this.$http.classApprove(_infoData).then(res => {
          if (res.data.status === "SUCCESS") {
            this.classPagelist();
            this.$message({ showClose: true, type: "success", message: res.data.msg });
          } else {
            this.$message({ showClose: true, type: "error", message: res.data.msg });
          }
          this.approveId = "";
        });
      }
    },
    /**批量审批教练员培训*/
    approveBatch() {
      if (this.selectionData.length === 0) {
        this.$confirm("请至少选择一项?", "提示", {
          showClose: true,
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning"
        });
        return;
      }
      this.selectionData.forEach(item => {
        this.approveArrId.push(item.trainingClassId);
      });
      this.isApproveBatch = true;
      this.openApprove("approve");
    },
    /**删除教练员培训*/
    classDelete(info) {
      this.$confirm(`此操作将删除 [ ${info.year}年 · ${info.name} ] , 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$http.classDelete(info.trainingClassId).then(res => {
            if (res.data.status === "SUCCESS") {
              this.classPagelist();
              this.$message({ showClose: true, type: "success", message: res.data.msg });
            } else {
              this.$message({ showClose: true, type: "error", message: res.data.msg });
            }
          });
        })
        .catch(() => {
          // this.$message({ showClose: true, type: "info", message: "已取消" });
        });
    },
    /* 导出 */
    handleExport() {
      this.$http.exportTrainingclass(this.ClassPageListVO).then(response => {
        var res = this.$http.data(response);
        if (this.$http.success(res)) {
          let a = document.createElement("a");
          let event = new MouseEvent("click");
          a.href = this.$http.formatStaticResourceUrl("excel/" + res.data);
          a.dispatchEvent(event);
        } else {
          this.$message.error({
            showClose: true,
            type: "error",
            message: res.msg
          });
        }
      });
    }
  }
};
</script>
<style lang="scss"></style>
